import React from 'react';

import { ExtranetExperienceStatus } from 'app/typings/core/extranet/hotel/experiences';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import type { ExperienceOpening } from '../../../../../utils/experiences';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { StatusCell } from '../../../../Table/Cells/StatusCell/StatusCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import { getStatusInfo } from '../../../inventoryStatusUtils';
import type { ExperienceRowProps } from '../../types';

const ExperienceStatusRowComponent: React.FC<ExperienceRowProps> = ({
  experienceId,
}) => {
  const { inventoryExperiences, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Experiences
  );

  if (!inventoryExperiences) {
    return null;
  }

  return (
    <TableRow isHeader>
      <LabelCell label="Status" />
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, String(experienceId)];

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: ExperienceOpening) => {
              const statusInfo = values ? getStatusInfo(values) : undefined;

              return (
                <StatusCell
                  status={
                    values?.inventoryStatus ??
                    ExtranetExperienceStatus.PUBLISHED
                  }
                  tooltipText={statusInfo?.label}
                  name={fieldName}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const ExperienceStatusRow = React.memo(ExperienceStatusRowComponent);
